import { render, staticRenderFns } from "./newaddress.vue?vue&type=template&id=4aa6dbaa&"
import script from "./newaddress.vue?vue&type=script&lang=js&"
export * from "./newaddress.vue?vue&type=script&lang=js&"
import style0 from "./newaddress.vue?vue&type=style&index=0&id=4aa6dbaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports